export const defaultFont='sans-serif';
export const defaultFontSize='70px';
export const defaultFontColor='#000';
export const defaultTypingSpeed=20;